export const getCharacters = (state) => state.characters;
export const getDifficulty = (state) => state.difficulty;
export const getFont = (state) => state.font;
export const getIsChinese = (state) => state.isChinese;
export const getShowSettings = (state) => state.showSettings;
export const getSudokuBoard = (state) => state.sudokuBoard;
export const getSolutionBoard = (state) => state.solutionBoard;
export const getSize = (state) => (state.sudokuBoard && state.sudokuBoard.length) || 0;
